import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=b3fb3f5c&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3fb3f5c')) {
      api.createRecord('b3fb3f5c', component.options)
    } else {
      api.reload('b3fb3f5c', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=b3fb3f5c&", function () {
      api.rerender('b3fb3f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9cxPCNEdpbi/JS/videoIframe.vue"
export default component.exports